import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {omit} from 'ramda';

import {Button as DXButton} from 'devextreme-react';


export default class Button extends Component {
    constructor(props) {
        super(props);

        this.button = React.createRef();

        this.state = {
            visible: this.props.visible,
            disabled: this.props.disabled,
            // form: {}
        };

        this.onClick = this.onClick.bind(this);
    }

    // UNSAFE_componentWillReceiveProps(props) {
    //     if (
    //         (this.state.visible !== props.visible)
    //         || (this.state.disabled !== props.disabled)
    //     ) {
    //         this.setState({
    //             visible: props.visible,
    //             disabled: props.disabled,
    //         })
    //     }
    // }

    static getDerivedStateFromProps(nextProps, prevState){
        if ((nextProps.visible !== prevState.visible) || (nextProps.disabled !== prevState.disabled)) {
            return {
                visible: nextProps.visible,
                disabled: nextProps.disabled,
            };
        }
        return null;
    }

    onClick(e) {
        const {setProps} = this.props;

        // console.log(this.button.form.components)

        if (setProps) {
            setProps({
                n_clicks: this.props.n_clicks + 1,
                n_clicks_timestamp: Date.now()
            })
        }
    }

    render() {
        const dataAttributes = {};
        if (this.props.loading_state && this.props.loading_state.is_loading) {
            dataAttributes['data-dash-is-loading'] = true;
        }
        return (
            <DXButton
                {...omit(['n_clicks', 'n_clicks_timestamp', 'loading_state', 'setProps'], this.props)}
                {...dataAttributes}
                ref={this.button}
                visible={this.state.visible}
                disabled={this.state.disabled}
                onClick={this.props.onClick || this.onClick}
            />
        )
    }
}

/*
export default class Button extends Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: props.visible,
            disabled: props.disabled,
        };

        this.onClick = this.onClick.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        // if (
        //     (this.state.visible !== props.visible)
        //     || (this.state.disabled !== props.disabled)
        // ) {
        //     this.setState({
        //         visible: props.visible,
        //         disabled: props.disabled,
        //     })
        // }
        return (
            (this.state.visible !== nextProps.visible)
            || (this.state.disabled !== nextProps.disabled)
        )
    }

    onClick(e) {
        const {setProps} = this.props;

        if (setProps) {
            setProps({
                n_clicks: this.props.n_clicks + 1,
                n_clicks_timestamp: Date.now()
            })
        }
    }

    render() {
        const dataAttributes = {};
        if(this.props.loading_state && this.props.loading_state.is_loading) {
            dataAttributes['data-dash-is-loading'] = true;
        }
        return (
            <DXButton
                {...omit(['n_clicks', 'n_clicks_timestamp', 'loading_state', 'setProps'], this.props)}
                {...dataAttributes}
                visible={this.state.visible}
                disabled={this.state.disabled}
                onClick={this.props.onClick || this.onClick}
            />
        )
    }
}
*/

/*
const Button = (props) => {
    const dataAttributes = {};
    if(props.loading_state && props.loading_state.is_loading) {
        dataAttributes['data-dash-is-loading'] = true;
    }

    const [visible, setVisible] = useState(true);
    const [disabled, setDisabled] = useState(false);
    // const [nClicks, setNClicks] = useState(0);
    // const [nClicksTimestamp, setNClicksTimestamp] = useState(null);
    // setVisible(props.visible);
    // setVisible(props.disabled);
    const onClick = (e) => {
        const {setProps} = props;

        if (setProps) {
            setProps({
                n_clicks: props.n_clicks + 1,
                n_clicks_timestamp: Date.now()
            })
        }
        // if (fireEvent) fireEvent({event: 'click'});
    };

    return (
        <DXButton
            {...omit(['n_clicks', 'n_clicks_timestamp', 'loading_state', 'setProps'], props)}
            {...dataAttributes}
            onClick={props.onClick || onClick}
            visible={visible}
            disabled={disabled}
        />
    );
};
*/
Button.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,

    accessKey: PropTypes.string,
    activeStateEnabled: PropTypes.bool,
    component: PropTypes.string,
    disabled: PropTypes.bool,
    elementAttr: PropTypes.object,
    focusStateEnabled: PropTypes.bool,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    hint: PropTypes.string,
    hoverStateEnabled: PropTypes.bool,
    icon: PropTypes.string,
    onClick: PropTypes.func,
    onContentReady: PropTypes.func,
    onDisposing: PropTypes.func,
    onInitialized: PropTypes.func,
    onOptionChanged: PropTypes.func,
    render: PropTypes.string,
    rtlEnabled: PropTypes.bool,
    stylingMode: PropTypes.oneOf(['text', 'outlined', 'contained']),
    tabIndex: PropTypes.number,
    template: PropTypes.oneOf(['content', 'icon', 'text']),
    text: PropTypes.string,
    type: PropTypes.oneOf(['back', 'danger', 'default', 'normal', 'success']),
    useSubmitBehavior: PropTypes.bool,
    validationGroup: PropTypes.string,
    visible: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),

    n_clicks: PropTypes.number,
    n_clicks_timestamp: PropTypes.number,

    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func

    // /**
    //  * A callback for firing events to dash.
    //  */
    // fireEvent: PropTypes.func,

    // dashEvents: PropTypes.oneOf(['click'])
};

Button.defaultProps = {
    accessKey: null,
    activeStateEnabled: true,
    component: null,
    disabled: false,
    elementAttr: {},
    focusStateEnabled: true,
    height: 'auto',
    // hint: undefined,
    hoverStateEnabled: true,
    icon: '',
    onClick: null,
    onContentReady: null,
    onDisposing: null,
    onInitialized: null,
    onOptionChanged: null,
    render: null,
    rtlEnabled: false,
    stylingMode: 'contained',
    tabIndex: 0,
    template: 'content',
    text: '',
    type: 'normal',
    useSubmitBehavior: false,
    // validationGroup: undefined,
    visible: true,
    width: 'inherit',

    n_clicks: 0,
    n_clicks_timestamp: -1
};

// export default Button;
